<template>
  <PageLoadMore v-if="state.article" :data="state.article" />
</template>

<script setup lang="ts">
import useArticle from '~/composables/useArticle';
import type { TArticle, TArticleType } from '~~/types/local_types';

definePageMeta({
  scrollToTop: true,
});

const articleType: TArticleType = 'uitlegvideos';

interface IState {
  article?: TArticle;
  variant: string;
  redirectChecked?: boolean;
}

const state: IState = reactive({
  variant: useIsChildPageOf(),
});

const article = await useArticle(articleType);
if (!article || !article.slug) {
  throw createError({ statusCode: 404, statusMessage: 'Artikel niet gevonden' });
}
state.article = article;

usePageSeo({ content: article });

if (import.meta.client) {
  sendAnalytics({ prefix: 'uitlegvideos', slug: article.slug });
}

state.redirectChecked = await useCheckRedirect(
  article.slug,
  article.articleType,
  article.externalUrl,
);

onMounted(() => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
});
</script>

<style scoped lang="postcss"></style>
